import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { PreviewDrawerLineStyled } from "@ryde/controls";
import { BACKUP_CREATE_SUMMARY_PATTERN } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

import { ProcessDrawerContext } from "../process-drawer-context";

// Replaces the generic "Successful" line for the on-demand backup process. The generic one counts
// affected row ids, which a backup has none of — its unit of work is an entity dump per scope, so it
// would always read 0 / 0. Counts are parsed from the process completion log line.
export const ProcessStatisticBackupCreate: FC = () => {
  const { t } = useTranslation();
  const { currentProcess } = useContext(ProcessDrawerContext);

  const summary = currentProcess?.logs?.find(line =>
    line.includes("entity dumps"),
  );
  const counts = summary?.match(BACKUP_CREATE_SUMMARY_PATTERN);
  const dumped = counts ? Number(counts[1]) : 0;
  const total = counts ? Number(counts[2]) : 0;
  const scopeCount = counts ? Number(counts[3]) : 0;
  const failed = Math.max(total - dumped, 0);

  return (
    <>
      <PreviewDrawerLineStyled $numberColor={rydeColors.green}>
        <span>{t("backup.create.dumped", "Entity dumps")}</span>
        <span>{`${dumped} / ${total}`}</span>
      </PreviewDrawerLineStyled>
      {failed > 0 && (
        <PreviewDrawerLineStyled $numberColor={rydeColors.red}>
          <span>{t("backup.create.failedDumps", "Failed")}</span>
          <span>{failed}</span>
        </PreviewDrawerLineStyled>
      )}
      <PreviewDrawerLineStyled>
        <span>{t("backup.create.scopeCount", "Scopes")}</span>
        <span>{scopeCount}</span>
      </PreviewDrawerLineStyled>
    </>
  );
};
